__turbopack_context__.v({
  "artistCard": "Hero-module-scss-module__k5_y-q__artistCard",
  "card": "Hero-module-scss-module__k5_y-q__card",
  "cards": "Hero-module-scss-module__k5_y-q__cards",
  "container": "Hero-module-scss-module__k5_y-q__container",
  "ctaButton": "Hero-module-scss-module__k5_y-q__ctaButton",
  "hero": "Hero-module-scss-module__k5_y-q__hero",
  "musicWaveCard": "Hero-module-scss-module__k5_y-q__musicWaveCard",
});
